<template>
  <div class="main">
    <ball></ball>
    <div class="nav">
      <Nav title="报告详情" :fixed="true"></Nav>
      <div class="top"></div>
    </div>
    <div class="pdf" ref="content">
      <iframe
        v-if="showpdf"
        :src="href"
        frameborder="0"
        width="100%"
        height="90%"
      ></iframe>
      <!-- <iframe :src="pdfUrl" style="border: none;width: 100%;height: 100%;" frameborder="0" /> -->
    </div>
    <div class="btn">
      <!-- <van-button size="large" type="info" @click="downloadIamge()"
        >预览报告</van-button
      >
      <van-button
        size="large"
        type="primary"
        style="margin-top: '10px'"
        @click="godownload()"
        >下载</van-button
      > -->
    </div>
  </div>
</template>
  
  <script>
import Nav from "../../../components/nav.vue";
import pdf from "vue-pdf";
import html2canvas from "html2canvas";
export default {
  components: {
    pdf,
    Nav,
  },
  data() {
    return {
      showpdf: false,
      href: "",
      reportBase64: "",
      src: "",
      numPages: 0,
      page: 1,
      currentPage: 0,
      imgUrl: "",
      CreateDate: "",
      ReportId: "",
      pdfSrc: "",
      pdfUrl: "",
    };
  },
  created() {
    console.log(this.$route.query);
    this.CreateDate = this.$route.query.CreateDate;
    this.ReportId = this.$route.query.ReportId;
  },
  mounted() {
    this.getReport();
  },
  methods: {
    godownload() {
      window.location.href = this.url;
    },
    downloadIamge() {
      html2canvas(this.$refs.content).then((resolve) => {
        this.imgUrl = resolve.toDataURL("image/png"); //此时就得到了dom元素转成了base64的图片
        // console.log(this.imgUrl);
        WeixinJSBridge.invoke("imagePreview", {
          urls: [this.imgUrl],
          current: this.imgUrl,
        });
      });
    },

    async getReport() {
      console.log(123123);
      try {
        let reqData = {
          CreateDate: this.CreateDate, //"2020038924",
          ReportId: this.ReportId,
        };
        this.$showLoad();
        let url = "/report/NewDyPacsIo1";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          reqData,
          (data) => {
            this.url = data.url;
            this.$hideLoad();
            this.pdfSrc = data.data.data;
            this.getObjectURL(this.pdfSrc);
            // let base64 = data.data.data.Data.PacsBase64Str
            // // console.log(base64);
            // this.reportBase64 = base64;
            // let datas = "data:application/pdf;base64," + base64; //  data:image/jpeg;base64,

            // this.src = pdf.createLoadingTask({ url: datas, CMapReaderFactory });
            // // this.src.promise.then((pdf) => {
            // //   this.numPages = hospitalChekedDetail.numPages;
            // // });
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    dataURLtoBlob(dataurl) {
      var bstr = atob(dataurl);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: "pdf" });
    },
    getObjectURL(data) {
      let url = null;
      let file = new Blob([data], { type: "application/pdf;chartset=utf-8" });
      if (window.createObjectURL != undefined) {
        // 通用
        url = window.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        // 兼容谷歌
        try {
          url = window.webkitURL.createObjectURL(file);
        } catch (error) {}
      } else if (window.URL != undefined) {
        // 兼容其他
        try {
          url = window.URL.createObjectURL(file);
        } catch (error) {}
      }
      // 将转化后url赋值
      this.pdfUrl = url;
      this.href = "./web/viewer.html?file=" + this.pdfUrl;
      this.showpdf = true;
    },
    test() {
      let URL = this.dataURLtoBlob(this.reportBase64);
      let name = this.name + this.itemName + "报告单.pdf";
      var reader = new FileReader();
      reader.readAsDataURL(URL);
      reader.onload = function (e) {
        if (window.navigator.msSaveOrOpenBlob) {
          var bstr = atob(e.target.result.split(",")[1]);
          var n = bstr.length;
          var u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          var blob = new Blob([u8arr]);

          // console.log(name);
          window.navigator.msSaveOrOpenBlob(blob, name);
        } else {
          // 转换完成，创建一个a标签用于下载
          const a = document.createElement("a");
          a.download = name; // 这里写你的文件名
          a.href = e.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      };
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  width: 100%;
  .nav {
    height: 8vh;
  }
  .pdf {
    height: 95vh;
    width: 95%;
    margin: 0px auto;
    overflow: scroll;
  }
  .btn {
    height: 10vh;
    width: 95%;
    margin: 0px auto;
  }
}
</style>